<div class="container-workers">
    <div class="container-workers__wrapper">
        <div class="header flex-row">
            <button (click)="back()" [disabled]="isSaving" class="header__back">
                <i class="pi pi-angle-left"></i>
            </button>
            <h1 class="header__title">
                {{'worker.configure-worker'|translate}}
            </h1>
        </div>

        <form [formGroup]="form">
            <div class="content">
                <div class="form-wrapper">
                    <div class="form-wrapper__form">
                        <h2 class="form-wrapper__form__title">
                            {{'worker.basic-data'|translate}}
                        </h2>

                        <input formControlName="firstName" type="text" pInputText [placeholder]="'labels.first-name'|translate" />
                        <input formControlName="lastName" type="text" pInputText [placeholder]="'labels.last-name'|translate" />
                        <input formControlName="phone" type="text" pInputText [placeholder]="'labels.phone-number-optional'|translate" />

                        <div class="form-wrapper__form__control-wrapper">
                          <div class="form-wrapper__form__control-wrapper__input-wrapper">
                            <input formControlName="driverLicense" type="text" pInputText [placeholder]="'driverLicenseInputPlaceholder'|translate" />
                            <div
                              [pTooltip]="driverLicenseHintTooltip"
                              tooltipPosition="right"
                              tooltipStyleClass="tooltip-driver-licesnse-number"
                              class="form-wrapper__form__control-wrapper__input-wrapper__hint"
                            >
                              <i class="pi pi-question icon"></i>
                            </div>
                          </div>
                          <div *ngIf="driverLicesnseControl?.invalid && driverLicesnseControl?.touched">
                            <small class="error-text">
                              {{'errorDriverLicenseNumber' | translate}}
                            </small>
                          </div>
                        </div>

                        <input formControlName="email" type="text" pInputText [placeholder]="'labels.email-optional'|translate" />
                    </div>

                    <div class="actions-form">
                        <button (click)="submit()" [disabled]="isSaving" pButton type="button" [label]="'labels.save'|translate" class="actions-form__submit"></button>
                        <button (click)="back()" [disabled]="isSaving" pButton pRipple type="button" [label]="'labels.cancel'|translate" class="p-button-text p-button-plain" icon="pi pi-times" iconPos="left"></button>
                    </div>

                    <div *ngIf="!isAddNewWorker" class="archive-worker">
                        <span class="archive-worker__title">
                            {{'worker.archive-worker'|translate}}
                        </span>
                        <button (click)="archiveWorker()" pButton pRipple type="button" [disabled]="isSaving || editedWorkerData?.U" [label]="'worker.move-to-archive'|translate" class="p-button-danger p-button-text" icon="pi pi-inbox" iconPos="left"></button>
                    </div>
                </div>
            </div>
        </form>

    </div>
</div>

<ng-template #driverLicenseHintTooltip>
  <app-driver-license-hint></app-driver-license-hint>
</ng-template>
